import * as Style from './styles';

export const ListItem = ({children}) => {
    return(
        <Style.Ul >
            {children}
        </Style.Ul>
    )
}